export enum UrlValidationType{
    FQDN = 1,
    LocalHost,
    IntranetServer
}
